import Box from '@mui/material/Box'
import * as React from 'react'

export function SadMagnifyingGlassImage() {
  return (
    <Box>
      <img
        alt="No activity found baseed on filter selection"
        src="static-assets/icons/no-search-results.svg"
      />
    </Box>
  )
}
